import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { setUser } from "../../redux/User";

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = async () => {
        const response = await fetch(process.env.REACT_APP_API_URL + '/app/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });
        const data = await response.json();

        if (data.ResultCode === '0') {
            Cookies.set('api_token', data.api_token, { expires: 7 });
            localStorage.setItem('customer_id', data.customer_id);
            dispatch(setUser(data.user));
            window.location.href = "/user";
        } else if (data.ResultCode === '-4') {
            setErrorMessage('Invalid credentials. Please try again.');
        } else {
            setErrorMessage('An error occurred: ' + data.message);
        }
    };

    const handleRegistration = () => {
        navigate("/register");
    }

    return (
        <div className="flex justify-center h-screen mt-6">
            <div className="w-full max-w-md p-6">
                <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
                {errorMessage && (
                    <div className="mb-4 red-color text-center">
                        {errorMessage}
                    </div>
                )}
                <div className="mb-4">
                    <label className="block text-gray-700 p-2 font-bold">Email</label>
                    <input
                        type="email"
                        value={email}
                        required={true}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                    />
                </div>
                <div className="mb-6">
                    <label className="block text-gray-700 p-2 font-bold">Password</label>
                    <input
                        type="password"
                        value={password}
                        required={true}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                    />
                </div>
                <button
                    onClick={handleLogin}
                    className="w-full bg-second-bg text-white py-2 rounded-lg hover:bg-blue-700 transition duration-200 font-bold"
                >
                    Login
                </button>

                <a href={"/reset-password"} className="text-blue-500 hover:underline mt-2 block text-center">Forgot Password?</a>

                <button
                    onClick={handleRegistration}
                    className="w-full bg-primary-bg mt-4 text-white py-2 rounded-lg hover:bg-gray-700 transition duration-200 primary-color font-bold"
                >
                    Registration
                </button>
            </div>
        </div>
    );
};

export default Login;
